export interface Atividade {
  nome: string;
  valor: string;
}

// Seção 1 — Identificação dos Parceiros
export interface IdentificacaoParceiros {
  // 1º PARCEIRO – ICT Pública
  razaoSocial?: string;
  cnpj?: string;
  endereco?: string;
  representanteLegal?: string;
  cargo?: string;
  telefone?: string;
  email?: string;

  // 2º PARCEIRO
  nomeParceiro?: string;
  razaoSocial2?: string;
  cnpj2?: string;
  endereco2?: string;
  representanteLegal2?: string;
  cargo2?: string;
  telefone2?: string;
  email2?: string;

  // Fundação de Apoio
  razaoSocialFundacao?: string;
  cnpjFundacao?: string;
  enderecoFundacao?: string;
  representanteLegalFundacao?: string;
  cargoFundacao?: string;
  telefoneFundacao?: string;
  emailFundacao?: string;

  // Coordenação UFC
  coordenador?: string;
  siape?: string;
  lotacao?: string;
  telefoneUFC?: string;
  emailUFC?: string;

  // Coordenação Parceiro
  coordenadorParceiro?: string;
  telefoneParceiro?: string;
  emailParceiro?: string;
}

// Seção 2 — Do Objeto
export interface ObjetoProjeto {
  tituloProjeto?: string;
  tipoProjeto?: string;
  areaConhecimento?: string;
}

// Seção 10 — Orçamento
export interface OrcamentoItem {
  bolsa: string;
  unidade: string;
  quantidade: number;
  valorUnitario: number;
  valorTotal?: number;
}

// Tabela de orçamento
export interface TabelaOrcamento {
  id: string;
  nomeDespesa: string;
  itens: OrcamentoItem[];
  subtotal?: string;
  tituloGrupo?: string;
}

export interface MeioItem {
  nome?: string;
  identificacao?: string; // SIAPE/CPF
  cargo?: string;
  funcao?: string;
}

// Rascunho geral do documento
export interface DraftData extends IdentificacaoParceiros, ObjetoProjeto {
  // Seção 3 — Caracterização
  objetivosGerais: string;        // HTML
  objetivosEspecificos: string;   // HTML

  // Seção 4 — Justificativa
  justificativa: string;          // HTML

  // Seção 5 — Descrição das Atividades
  responsabilidadesUFC: string;           // HTML
  responsabilidadesParceiro: string;      // HTML
  atividadesConjuntas: string;            // HTML

  // Seção 6 — Direitos de PI
  direitosPI: string;              // HTML

  // Seção 7 — Resultados Esperados
  atividades: Atividade[];

  // Seção 8 — Meios a Serem Empregados
  meios?: MeioItem[];           // 8.1 (tabela)
  meiosUfc?: MeioUfcItem[];        // 8.2 (tabela)
  recursosFinanceiros?: string; // 8.3 (HTML)
  infraestrutura?: string;      // 8.4 (HTML)

  // Seção 10 — Orçamento
  tabelas_orcamento: TabelaOrcamento[];
  nomeDespesa?: string;
  orcamento?: OrcamentoItem[];
  totalOrcamento?: number;
}

export type MeioUfcItem = {
  nome?: string;
  identificacao?: string;
  email?: string;
  fone?: string;
  funcao?: string;
};

export type DraftPatch = Partial<DraftData>;

export enum Action {
  suggest_new = "suggest_new",
  textual_review = "textual_review",
  critical_review = "critical_review",
  rewrite = "rewrite",
  shrink = "shrink"
}

export interface PlanContext {
  policy_version?: string;
  partnership_type?: string;
  institution_id?: string;
  user_role?: string;
  locale?: string;
}

export interface AssistOptions {
  target_tone?: string;
  shrink_percent?: number;
  max_chars?: number;
  check_consistency?: boolean;
  enforce_normative_refs?: boolean;
}

export interface SectionAssistRequest {
  action: Action;
  section_key: keyof DraftData;
  plan: DraftData;
  context?: PlanContext;
  options?: AssistOptions;
  request_id?: string;
}

export interface Suggestion {
  new_text?: string;
  rationale?: string;
  diff?: Record<string, any>;
  quality_score?: number;
  warnings: string[];
}

export interface SectionAssistResponse {
  action: Action;
  section_key: string;
  suggestions: Suggestion[];
  usage?: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
}